import {lib_en_CA} from '@docupet/component-library';
import en_CA from '@/translations/en-CA';

export default {
    ...lib_en_CA,
    ...en_CA,
};
